/*
 * @Author: your name
 * @Date: 2023-01-29 12:48:25
 * @LastEditors: your name
 * @LastEditTime: 2023-03-08 15:58:49
 * @FilePath: /developer-black/src/app/routes/project/project-detail/eois/eoi-detail-dialog/eoi-detail-dialog.ts
 * @Description: 
 * 
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved. 
 */
import { Component, EventEmitter, Input, OnInit, Output, Inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpService } from "../../../../../core";
import { MatDialog } from "@angular/material/dialog";
import { ButtonDialogComponent } from "../eoi-detail/button-dialog/button-dialog.component";
import { environment } from "../../../../../../environments/environment";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'eoi-detail-dialog',
    templateUrl: './eoi-detail-dialog.html',
    styleUrls: ['./eoi-detail-dialog.scss']
})
export class EoiDetailDialog implements OnInit {
    SERVER_URL = environment.SERVER_URL;

    @Input() eoiId: number;
    @Output() closeDetail = new EventEmitter();

    eoiDetail: any;
    agentEmail: string = '';
    agentMobile: string = '';

    constructor(
        private route: ActivatedRoute,
        private httpService: HttpService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }


    ngOnInit() {
        console.log(this.data, 'this.data.eoiId')
        this.httpService.getEoiDetail(this.data.eoiId).toPromise().then((res: any) => {
            console.log('this.eoiDetail',res.data)
            this.eoiDetail = res.data
            if (res.data.agent) {
                this.agentEmail = res.data.agent.contacts.filter(e => e.contactItem.title.en == 'Email')[0].content
                this.agentMobile = res.data.agent.contacts.filter(e => e.contactItem.title.en == 'Phone Number')[0].content
            }
        })
    }

    close() {
        this.dialogRef.close()
    }

    approve() {
        this.dialog.open(ButtonDialogComponent, { data: { type: "approve" } }).afterClosed().subscribe(result => {
            if (result.type) {
                this.httpService.approvedEoi(this.data.eoiId).toPromise().then(res => {
                    // this.ngOnInit()
                    this.dialogRef.close('success');
                })
            }
        })
    }

    reject() {
        this.dialog.open(ButtonDialogComponent, { data: { type: "reject" } }).afterClosed().subscribe(result => {
            if (result.type) {
                this.httpService.rejectEoi(this.data.eoiId, { rejectReason: result.remark }).toPromise().then(res => {
                    // this.ngOnInit()
                    this.dialogRef.close('success');
                })
            }
        })
    }

    remove() {
        this.dialog.open(ButtonDialogComponent, { data: { type: "remove" } }).afterClosed().subscribe(result => {
            if (result.type) {
                this.httpService.removeEoi(this.data.eoiId, { rejectReason: result.remark }).toPromise().then(res => {
                    // this.ngOnInit()
                    this.dialogRef.close('success');
                })
            }
        })
    }

    openReceiptFile(fileName) {
        window.open(this.SERVER_URL + 'files/' + this.eoiDetail.eoiNo + '/receipt/' + fileName)
    }

    openEoiFile(fileName) {
        window.open(this.SERVER_URL + 'files/' + this.eoiDetail.eoiNo + '/form/' + fileName)
    }
}
